<template>

    <form @submit.prevent="onSubmit">
        
        <div class="">
            
            <br>

<!--             <b-field label="Name">
                
                <b-input v-model="form.name"></b-input>

            </b-field>
            <br> -->
            
           <!--  <b-field label="Code">
            
                <b-input v-model="form.councilId"></b-input>
            
            </b-field>

            <br>

            <tags-input label="Tags" allow-new :values.sync="selectedtags" />

            <br>
            
            <div class="columns">
                
                <div class="column">
            
                    <b-field label="Your Rating" v-if="organization" class="rating-div">
                    
                        <star-rating class="mb-1" :increment ="0.1" :rating="doneRate.rating" :star-size="20" :show-rating="false" read-only v-if="doneRate"/>

                        <star-rating class="mb-1" :increment ="0.1" :rating="0" :star-size="20" :show-rating="false" read-only v-else />

                        <template v-if="canRate && !doneRate">

                            <button class="button rate-button" type="button" @click="modal.active = true">Rate</button>

                            <b-modal :active.sync="modal.active" has-modal-card>

                                <rating-modal :rate="rate" />

                            </b-modal>

                        </template>

                        <p v-if="organization.ratings.length && doneRate">Notes: {{ doneRate.notes }}</p>

                    </b-field>
  
                </div>
    
                <div class="column" style="padding-top:30px;" v-if="firmTags.length">

                    <button :class="(tagExist(tag.id) ? 'is-info' : '') + ' button tags-button'" 

                    :disabled="selectedFirm.archived_at" v-for="(tag, key) in firmTags" 

                    @click.prevent="firmTag(tag, $event)">{{ tag.name }} </button>

                </div>

            </div> -->
    
        </div>

        <br>
        
        <footer class="">

            <div class="buttons" style="float:right;">
            
<!--                 <b-button class="organization-form-button" type="is-link" native-type="submit" :loading="loading" :disabled="!organization ? !canManageFirms : false">

                    <span v-if="organization">UPDATE</span>
                    
                    <span v-else>CREATE</span>
                
                </b-button>
 -->
                <template v-if="user.firm.id != organization.id">

                  <b-button class="organization-form-button" type="is-warning" @click="archive('archive')" v-if="!selectedFirm.archived_at">

                      <span>ARCHIVE</span>

                  </b-button>

                  <b-button class="organization-form-button" type="is-dark" @click="archive('restore')" v-else>

                      <span>RESTORE</span>

                  </b-button>

<!--                   <b-button class="organization-form-button" type="is-danger" @click="onRemove()">

                      <span>DELETE</span>

                  </b-button> -->
                  
                </template>

            </div>

        </footer>

    </form>

</template>

<script>

import RatingList from "@/components/Rating/RatingList";

import TagsInput from "@/components/partials/TagsInput";

import { FirmService } from "@/services/firm.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

import { TagService } from "@/services/tag.service";

import { AssociatedService } from "@/services/associated.service";

import StarRating from "vue-star-rating";

import RatingModal from "@/components/Rating/RatingModal";

export default {
  props: {
    height: {
      type: Number,
      default: 500
    },
    organization: {
      type: Object
    },
    selectedFirm:{
      type: Object
    },

    organizations: {
      type: Array
    }

  },

  components: { RatingList, TagsInput, StarRating, RatingModal },
  
  data: () => ({
    firmService: FirmService,
    form: {
      name: "",
      councilId: "",
      // managed_by: '',
      children: [],
      tags: []
    },
    loading: false,
    archiving: false,
    restoring: false,
    deleting: false,

    modal: {
        active: false
    },

    firmTags: [],

    activeTags: {},


    // selectedtags: [],

  }),
  computed: {
    scrollableHeight() {
      return this.height - 44 - 56; // header height, footer height
    },
    user() {
      return this.$store.state.Auth.user;
    },

    // hasRating() {
    //   return !!this.ratings.find(rating => rating.createdBy.id == this.user.id);
    // },

    canRate() {

        return this.$store.getters["Auth/hasFirmPermission"]("can rate firms");

      // return (
        // this.user.firm.id !== this.organization.id &&
        // this.canManageFirms &&
        // this.$store.getters["Auth/hasFirmPermission"]("can rate firms")
      // );
    },

    doneRate() {

        return this.organization.ratings.find(element => {

            return element.createdBy.id == this.user.id;

        });

    },

    canManageFirms() {
      return this.$store.getters["Auth/hasPermission"]("can manage firms");
    },

    selectedtags: {

        get() {
            
            return this.selectedFirm.tags.filter(element => this.firmTags.every(tag => tag.id != element.id)).map(element => element.name);

        }, set(value) {

            // return value;

            // return value.filter(element => {

            //     console.log(element);

            //     return element.id == 50; 

            // });

            // return value;

        }

    }



  },
  watch: {

    // organization: {
    //   handler(organization) {


    //     if (this.organization) {
          
    //       this.firmService.show(this.organization.id, {includes: 'children,tags'}).then(response => {
    //         const firm = JsonDenormalizer.denormalize(response);

    //         this.form = {
    //           name: organization.name,
    //           councilId: organization.council_id,
    //           // activityOwner: organization.activity_owner || 0,
    //           tags: firm.tags ? firm.tags.map(tag => tag.name) : [],
    //           children: firm.children
    //             ? firm.children.map(child => child.id)
    //             : []
    //         }

    //       });

    //     } else {
    //       this.resetForm();
    //     }
    //   },
    //   deep: true
    // }

    organization(value) {


    },

    selectedFirm(value) {

        // this.form.managed_by = value.firm.managed_by;

        this.form.name = value.firm_name;

        this.form.councilId = value.code;

        this.activeTags = {};

    },


  },
  methods: {

    getChildrens(data) {

      return data.relationships.children.data.map(child => child.id);

      return [];

    },

    transformedData() {

      let formData = new FormData();

      formData.append("name", this.form.name);

      formData.append("code", this.form.councilId);

      // formData.append("managed_by", this.form.managed_by);

      formData.append("firm_firm_id", this.selectedFirm.id);
      
      formData.append("firm_id", this.organization.id);

      formData.append("tags", this.selectedtags.toString());

      // formData.append("active_tags", this.activeTags.toString());

      let active_tags = [];

      Object.entries(this.activeTags).forEach(([key, value]) => {

        active_tags.push(value);
      
      });

      formData.append("active_tags", active_tags.toString());


      // formData.append("activity_owner", this.form.activityOwner);

      // if (this.form.logo) {
      //   formData.append("file", this.form.logo);
      // }

      // this.form.permissions.forEach(permission => {
      //   formData.append("permission_ids[]", permission);
      // });





      // if (this.organization) {
      //   this.form.children.forEach(child => {
      //     formData.append("children[]", child);
      //   });
      // }

    // this.form.tags.forEach(tag => {
    
    //     // formData.append("tags[]", tag);
    
    // });



      // formData.append("includes", "children");

      return formData;

    },


    resetForm() {
      this.form = {
        name: "",
        councilId: "",
        // activityOwner: 0,
        tags: []
        // permissions: []
      };
    },
    onSubmit() {


      if (this.organization) {
        this.update();
      } else {
        this.create();
      }
    },
    cancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    async create() {
      this.loading = true;

      try {
        await this.firmService.store(this.transformedData());

        this.$buefy.toast.open({
          message: "Organization has been created.",
          type: "is-info",
          position: "is-top-right"
        });
        this.resetForm();
        this.$emit("create-success");
      } catch (err) {}

      this.loading = false;
    },
    async update() {

        AssociatedService.update(this.transformedData()).then(response => {

            this.$buefy.toast.open({
        
                message: 'Associated Organization has been updated.',
            
                type: "is-info",
            
                position: "is-top-right"
        
            });

            this.$emit('updateFirm', response)


        });

    },
    
    async archive(type) {

        this.archiving = true;

        AssociatedService.archive({id: this.selectedFirm.id}).then(response => {

            this.$buefy.toast.open({
        
                message: type == 'archive' ? 'Associated Organization has been archived.' : 'Associated Organization has been restored.',
            
                type: "is-info",
            
                position: "is-top-right"
        
            });

            this.$emit('updateFirm', response)

        });

        this.archiving = false;

    },

    async restore() {

        this.restoring = true;

        try {

            const response = await FirmService.restore(this.organization.id);

            this.$buefy.toast.open({

                message: "Organization has been restored.",
                
                type: "is-info",
                
                position: "is-top-right"
            
            });
        
            this.$emit('updateOrganization', JsonDenormalizer.denormalize(response))
        
        } catch (err) {}

        this.restoring = false;

        // this.$emit('refetchOrganization');

    },


    onRemove() {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>delete</b> this associated organization?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.remove();
        }
      });
    },
    async remove() {

        this.deleting = true;

        await AssociatedService.delete({id: this.selectedFirm.id}).then(response => {

            this.$buefy.toast.open({
        
                message: 'Associated Organization has been deleted.',
            
                type: "is-info",
            
                position: "is-top-right"
        
            });

            this.$emit('reset')

        });

        this.deleting = false;

      // alert('Action to follow');

      // this.deleting = true;

      // try {
      //   await this.firmService.delete(this.organization.id);

      //   this.$buefy.toast.open({
      //     message: "Organization has been deleted.",
      //     type: "is-info",
      //     position: "is-top-right"
      //   });
      //   this.$emit("remove-success");
      // } catch (err) {}

      // this.deleting = false;
    },
    
    // async rate(data) {
    //   try {
    //     const firm = await this.firmService.rate(this.organization.id, data).then(response => JsonDenormalizer.denormalize(response));
        
    //     if (firm.ratings) {
    //       this.$set(this.organization, "ratings", firm.ratings);
    //     }
    //   } catch (err) {
    //     throw err;
    //   }
    // },

    async rate(data) {

        await FirmService.rate(this.organization.id, data).then(response => {

            this.$emit('updateOrganization', JsonDenormalizer.denormalize(response))

            this.modal.active = false;

        });

    },


    getTags() {

        TagService.findtags({tags: ['customer', 'vendor']}).then(response => {

            this.firmTags = JsonDenormalizer.denormalize(response);

        });

    },

    firmTag(tag, event) {

        event.target.classList.toggle('is-loading');

        TagService.attachtag({tag: tag.id, parent_id: this.user.firmId, child_id: this.organization.id}).then(response => {

            event.target.classList.toggle('is-info');

            event.target.classList.toggle('is-loading');

            this.$emit('updateFirm', response)

        });

    },

    tagExist(id) {

      let data = this.selectedFirm.tags.filter(element => element.id == id && element.pivot.archived_at == null);

      if (data.length) {

        this.activeTags[id] = data[0].id;

        return true;

      }

      return false;

    }


  },

  mounted() {

    this.form = {

        name: this.selectedFirm.firm_name,

        councilId: this.selectedFirm.code,
        
        // managed_by: this.selectedFirm.firm.managed_by,
    
    }

    this.getTags();


  }


};
</script>

<style scoped>

.logo {
    width: 300px !important;
    height: 100px !important;
    object-fit: contain;
}

.rating-div{
    display: block;
}

.tags-button{
    
    margin: 5px 0px;
    float: right;
    width: 100px;

}

.tags-button:first-child {

    margin-left: 5px;

}

.organization-form-button{
  float: right;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationForm.vue